<style scoped>
.buttonRight {
  text-align: end;
  padding-bottom: 10px;
}
</style>
<template>
  <div>
    <TableReport ref="tableReportList" form-name="casing" :field-id="fieldId" :pad-id="padId" :well-id="wellId" :form-id="fromId" :selected-row-table="assignSelectedRow" />
    <div v-if="selectedRow.length > 0">
      <hr />
      <b-row>
        <b-col>
          <span class="font-weight-bold mx-2">Report no. {{selectedRow[0].submitId}}</span>
          <span v-if="confirmShow"> 
            Are you sure to {{confirmWording}} this report ? 
            <b-button-group>
            <b-button size="sm" variant="success" @click="submitApproval(approveAction)">Yes</b-button>
            <b-button size="sm" variant="danger" @click="no">No</b-button>
            </b-button-group>
          </span>
          <b-button-group v-if="!confirmShow">
            <b-button size="sm" variant="success" @click="confirm('approve')">Approved</b-button>
            <b-button size="sm" variant="danger" @click="confirm('reject')">Rejected</b-button>
          </b-button-group>
        </b-col>
        <b-col style="text-align: right;">
          <b-button size="sm" :variant="btnVarian" @click="toggleEdit">
            <b-icon-pencil v-if="!editStatus"></b-icon-pencil>
            <b-icon-circle-slash v-if="editStatus"></b-icon-circle-slash>
            {{editCaption}}
          </b-button>
        </b-col>
      </b-row>
      <hr />
      <Casing :submit-id="selectedRow[0].submitId" :editable="editable" />
    </div>
  </div>
</template>
<script>
import TableReport from '@components/form/approval/drilling-activity/appr-table'
import Casing from '@components/form/drilling-activity/casing-hole'
import { formMethods } from '@state/helpers'
export default {
  components: { TableReport, Casing },
  props: {
    wellId: { type: Number, default: undefined },
    padId: { type: Number, default: undefined },
    fieldId: { type: Number, default: undefined },
    countNo:Function
  },
  data() {
    return {
      fromId: 18,
      submitId: 0,
      editable: false,
      selectedRow: [],
      editStatus: false,
      editCaption: 'Edit',
      confirmShow : false,
      btnVarian: 'outline-primary', 
    }
  },
  watch:{
    wellId :function(val){
      this.wellId = val
    },
    padId:function(val){
      this.padId = val
    },
    fieldId :function(val){
      this.fieldId = val
    },
  },
  methods: {
    ...formMethods,
    assignSelectedRow(val) {
      this.selectedRow = val
    },
    countRowNo(val){
      this.countNo(val)
    },
    no(){
      this.confirmShow = false
    },
    confirm(val){
      this.confirmShow = true
      this.confirmWording = val
      this.approveAction = val==='approve'
    },
    submitApproval(approved) {
      // console.log(approved)
      this.updateApprovalStatus({params : {submitId:this.selectedRow[0].submitId,approved:approved}}).then((resp)=>{
        if(resp.status <300) this.$refs.tableReportList.refreshTable()
      })
    },
    toggleEdit() {
      this.editStatus = !this.editStatus
      if (this.editStatus) {
        this.editCaption = 'Stop Edit'
        this.btnVarian = 'outline-danger'
        this.editable = true
      } else {
        this.editCaption = 'Edit'
        this.btnVarian = 'outline-primary'
        this.editable = false
      }
    },
  },
}
</script>